import React from "react";
import * as Styled from "./AboutPinkStoriesStyles";
import NowSendStoryButton from "../buttons/nowSendStory/NowSendStoryButton";
import GeneralBreadcrumb from "../breadcrumb/GeneralBreadcrumbComp";

type IProps = {
    title?: string;
    contentTitle?: string;
    contentText?: string;
    breadcrumb?: any[];
}

const AboutPinkStories = (props: IProps) => {
    return (
        <Styled.AboutPinkStoriesContainer>
            <Styled.AboutPinkStoriesWrapper>
                {props.breadcrumb && (
                    <GeneralBreadcrumb items={props.breadcrumb} margin={true} colorProps={true} className={'mobile-mb-pt'}/>
                )}
                {props.title && (
                    <Styled.AboutPinkStoriesTitle>
                        {props.title}
                    </Styled.AboutPinkStoriesTitle>
                )}

                {props.contentTitle && (
                    <Styled.AboutPinkStoriesContentTitle>
                        Çünkü sizin hikayeniz sadece bir hikaye değil, mutluluğu arayan milyonların rüyası… Hikayenizi
                        paylaşın, alyanslarınızı biz hediye edelim.
                    </Styled.AboutPinkStoriesContentTitle>
                )}

                <Styled.AboutPinkStoriesContentText>
                    Pembe Panjur bugüne kadar sayısız yalnız insana hayat arkadaşını bulma konusunda rehberlik etti. Biz
                    olabilmenin mutluluğunu yaşayan ve yuvalarını sitemiz aracılığıyla kuranlar, evliliğe giden yolda
                    neleri tecrübe ettiklerini her bakımdan güven duydukları Pembe Panjur'la paylaştı. Beraberliklerine
                    vesile olduğumuz binlerce çift sitemize üye oldukları ilk günden bekarlıklarının son gününe kadar
                    ortaya koydukları başarı öyküleriyle bizi gururlandırdı. Biz çiftlerimizi bu süreçte hiç yalnız
                    bırakmadık, daima destekçileri olduk.
                </Styled.AboutPinkStoriesContentText>
                <Styled.AboutPinkStoriesContentText>
                    Eğer siz de Pembe Panjur ile mutluluğa adım attıysanız, hikayenizi bize yazın. Çünkü sizin hikayeniz
                    sadece bir hikaye değil, mutluluğu arayan milyonların rüyası…
                </Styled.AboutPinkStoriesContentText>
                <Styled.AboutPinkStoriesContentText>
                    Hikayeniz istediğiniz koşullarda yayınlanacak ve ödüllendirilecektir.
                </Styled.AboutPinkStoriesContentText>
                <Styled.AboutPinkStoriesButtonDesktop>
                    <NowSendStoryButton mobile={false}/>
                </Styled.AboutPinkStoriesButtonDesktop>
                <Styled.AboutPinkStoriesButtonMobile>
                    <NowSendStoryButton mobile={true}/>
                </Styled.AboutPinkStoriesButtonMobile>
            </Styled.AboutPinkStoriesWrapper>
        </Styled.AboutPinkStoriesContainer>
    );
}

export default AboutPinkStories;
